import React, { Component } from "react"
import SubnavigationItem from "./SubnavigationItem"

function splitIntoSubArray(arr, count) {
  var newArray = []
  while (arr.length > 0) {
    newArray.push(arr.splice(0, count))
  }
  return newArray
}

class SubnavigationFat extends Component {
  static defaultProps = {}

  render() {
    const { subnavigationItems } = this.props

    if (subnavigationItems?.length > 0) {
      let subnavigationItemsArray = [...subnavigationItems]
      let subnavigationRows = splitIntoSubArray(subnavigationItemsArray, 3)

      let subnavigation = subnavigationRows.map((item, key) => {
        return (
          <div key={key} className="sub-navigation__items sub-navigation__items--3">
            {item.map((item, key) => {
              const style = {
                "--block-color": item.backgroundColor,
                "--heading-color": item.headingColor,
                "--subHeading-color": item.subheadingColor,
              }
              return (
                <div key={key} className={`sub-navigation__item`} style={style}>
                  <SubnavigationItem itemData={item} />
                </div>
              )
            })}
          </div>
        )
      })

      return (
        <section className="deck deck--white">
          <div className="sub-navigation sub-navigation--fat">{subnavigation}</div>
        </section>
      )
    } else {
      return ""
    }
  }
}

export default SubnavigationFat
